import { useCallback, useEffect, useState } from "react";

import { useChangePolicyDefaultStripePaymentMethodMutation } from "@covertree/agent-portal-graphql";
import { Toast } from "@covertree/utils";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";

export function useChangeDefaultStripePaymentMethod(
  policyLocator: string,
  defaultPaymentMethodId: string,
  shouldTriggerRenewalReissuance: boolean
) {
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] =
    useState<string>();

  useEffect(() => {
    setSelectedPaymentMethodId(defaultPaymentMethodId);
  }, [defaultPaymentMethodId]);

  const [
    changePolicyDefaultStripePaymentMethod,
    { loading: isChangeDefaultStripeMethodLoading },
  ] = useChangePolicyDefaultStripePaymentMethodMutation({
    notifyOnNetworkStatusChange: true,
  });

  const onUpdateDefaultPaymentMethod = useCallback(async () => {
    if (isChangeDefaultStripeMethodLoading || !selectedPaymentMethodId) {
      return;
    }
    try {
      await changePolicyDefaultStripePaymentMethod({
        variables: {
          policyLocator,
          paymentMethodId: selectedPaymentMethodId,
        },
      });

      if (shouldTriggerRenewalReissuance) {
        Toast.showSuccess(
          "Payment details have been updated successfully, and the renewal issuance has been completed."
        );
      }
    } catch (e) {
      Toast.showError(
        getErrorMessageFromApolloError(e) ||
          (shouldTriggerRenewalReissuance
            ? "Renewal issuance failed. For assistance, visit the 'Contact Us' section."
            : "Could not update payment method. Please try again."),
        8_000
      );
    }
  }, [
    selectedPaymentMethodId,
    policyLocator,
    isChangeDefaultStripeMethodLoading,
  ]);

  return {
    loading: isChangeDefaultStripeMethodLoading,
    selectedPaymentMethodId,
    onUpdateDefaultPaymentMethod,
    setSelectedPaymentMethodId,
  };
}
